// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"c2ad04cb","186":"a88fb9a9","211":"6742885c","306":"6417a99c","316":"1139e13e","391":"319c4422","534":"00b04433","554":"ef1067b8","682":"2c1bd757","698":"c6f73d9c","748":"22d9e249","772":"85b62e56","926":"b1200f7d","966":"eb7aa0d7"}[chunkId] + ".chunk.js";
};